module.exports = __webpack_public_path__ + "static/media/dhl.918e3ece.png";